import { EventEmitter } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
var NewPasswordStepComponent = /** @class */ (function () {
    function NewPasswordStepComponent() {
        this.showNewPassword = false;
        this.showConfirmationPassword = false;
        this.resetPassword = new EventEmitter();
        this.passwordMatches = [
            { translate: 'CHARACTERS', regex: '^.{8,}$' },
            { translate: 'UPPER_CASE_LETTER', regex: '[A-Z]{1,}' },
            { translate: 'LOWER_CASE_LETTER', regex: '[a-z]{1,}' },
            { translate: 'ONE_DIGIT', regex: '[0-9]{1,}' },
            { translate: 'ONE_SPECIAL_CHARACTER', regex: '[^a-zA-Z0-9]{1,}' }
        ];
    }
    NewPasswordStepComponent.prototype.matchValue = function (regex, value) {
        if (!value) {
            return false;
        }
        return RegExp(regex).test(value);
    };
    return NewPasswordStepComponent;
}());
export { NewPasswordStepComponent };
